import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../common/icons/Icon';

export default ({ favorites }) => {
  return (
    <div className="favorites--widget">
      <div className="favorites--widget__header">
        <h4>My Favorites</h4>
        {favorites && !!favorites.length && <Link to="/subscription/library/favorites">VIEW ALL</Link>}
      </div>
      {favorites && favorites.length ? (
        <div className="favorites--widget__full">
          {favorites.map(favorite => (
            <Link
              className="favorites--widget__favorite"
              to={
                favorite.tvEpisode && favorite.tvEpisode.id ? (
                  `/subscription/tv/${favorite.tvEpisode.show_id}/${favorite.tvEpisode.id}`
                ) : (
                  `/subscription/library/favorites/videos/${favorite.libraryRecord.id}`
                )
              }
              key={favorite.id}
            >
              <div
                className="dash--vid-img"
                style={{
                  backgroundImage: `url(${favorite.tvEpisode && favorite.tvEpisode.image
                    ? favorite.tvEpisode.image.location
                    : favorite.libraryRecord.image.location})`,
                }}
              >
                <Icon icon="PlayCircle" />
              </div>
              <div className="fav-instance__desc">
                <h4>
                  {favorite.tvEpisode && favorite.tvEpisode.name ? (
                    favorite.tvEpisode.name
                  ) : (
                    favorite.libraryRecord.name
                  )}
                </h4>
                <p>
                  {favorite.tvEpisode && favorite.tvEpisode.description ? (
                    favorite.tvEpisode.description
                  ) : (
                    favorite.libraryRecord.description
                  )}
                </p>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="favorites--widget__empty">
          <h3>You Haven't Added Any Favorites Yet</h3>
          <div className="empty-state">
            Check out <Link to="/subscription/tv">Tathata TV</Link> or browse our {' '}
            <Link to="/subscription/library">Library</Link> videos and click <Icon icon="UnFavorite" /> to start
            favoriting! They'll show up here when you return.
          </div>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/subscription/dashboard/FavoritesWidget.js